import type { Problem } from '../types/content';

export const problems: Problem[] = [
  {
    title: 'Your hair transplant references are scattered',
    body: [
      'You have accumulated information from courses, textbooks, professional events, and research materials.',
      'But when you want to revisit a particular topic, finding the right reference can take longer than expected.',
    ],
    approach: 'Bring related educational topics together in one structured reference collection.',
  },
  {
    title: 'You want a more organized approach to patient assessment',
    body: [
      'Evaluating a potential hair restoration patient involves reviewing multiple considerations, including medical history, hair loss patterns, donor characteristics, expectations, and factors that may require further evaluation.',
      'You want a clear way to organize the information you study and document.',
    ],
    approach: 'Explore educational assessment frameworks and worksheets designed to organize relevant patient information.',
  },
  {
    title: 'You want to study hairline design more systematically',
    body: [
      'Hairline design involves aesthetic considerations, individual characteristics, and an understanding of facial proportions.',
      'You want a structured way to study these concepts rather than relying on disconnected examples.',
    ],
    approach: 'Access educational references covering hairline design principles, facial proportions, and individual variation.',
  },
  {
    title: 'You want to understand follicular unit anatomy more clearly',
    body: [
      'Follicular units, hair growth patterns, donor characteristics, and scalp anatomy are important subjects in hair restoration education.',
      'You want these concepts organized into a reference format that makes them easier to revisit.',
    ],
    approach: 'Study anatomical references and educational materials organized around follicular units and hair restoration fundamentals.',
  },
  {
    title: 'You need practical documentation resources',
    body: [
      'Patient assessment records, photographic documentation, treatment records, and follow-up notes all require appropriate organization.',
      'You want useful templates rather than another collection of disconnected explanations.',
    ],
    approach: 'Use educational documentation templates and worksheets that can be reviewed and adapted to your professional environment.',
  },
  {
    title: 'You want to organize your continuing professional education',
    body: [
      'Your professional knowledge develops over time.',
      'You want a reference library that makes it easier to revisit relevant concepts, compare information, and organize your learning.',
    ],
    approach: 'Maintain a structured educational collection covering major areas of hair transplant practice.',
  },
];
